import {
  Alert,
  Autocomplete,
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Modal,
  Paper,
  Popper,
  Skeleton,
  Snackbar,
  TextField,
  Typography,
  Link,
  CircularProgress,
} from "@mui/material";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Tabs from "@mui/material/Tabs";
import ShareIcon from "@mui/icons-material/Share";
import Tab from "@mui/material/Tab";
import Avatar from "@mui/material/Avatar";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Tooltip } from "@mui/material";
import CandidateInfo from "./candidateInfo";
import CandidateEditableProfile from "./CandidateEditableProfile";
import axios from "axios";
import { useSelector } from "react-redux";
import JobAssociated from "./JobAssociated";
import Cookies from "js-cookie";
import AddToJobBtn from "./addToJobBtn";
import DeleteCanidateDrawer from "./deleteCandidateDrawer";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import dayjs from "dayjs";
import Activities from "./Activities";
import AddLogActivity from "./AddLogActivity";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ height: "100%", overflowY: "hidden" }}
    >
      {value === index && <Box sx={{ height: "100%" }}>{children}</Box>}
    </div>
  );
}

const OpenDrawer = () => {
  const { id } = useParams();
  const [activitiesData, setActivitiesData] = useState({
    activityData: [],
    totalRows: 0,
  });
  const [searchParams] = useSearchParams();
  const [loadingActivities, setLoadingActivities] = useState(false);
  const [newvalues, setnewvalue] = useState(0);
  const tabFromUrl = parseInt(searchParams.get("tab") ?? "0", 10);
  const initialTab = Number.isNaN(tabFromUrl) ? 0 : tabFromUrl;
  const [value, setValue] = useState(initialTab);
  const [candidatedetails, setcandidatedetails] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const openDrawerId = useParams();
  const [addLogOpen, setAddLogOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [disableLogActivity, setDisableLogActivity] = useState(false);
  const [hoverBackButton, setHoverBackButton] = useState(false);
  const [openAddtoJob, setOpenAddtoJob] = useState(false);
  const [addToJobCandidateids, setAddToJobCandidateids] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [renderKey, setRenderKey] = useState(0);
  const IsEmployer = useSelector((state) => state.user.isEmployer);
  const role = useSelector((state) => state.user.role);
  const nav = useNavigate();
  const [filterOptions, setFilterOptions] = useState({
    regarding: [],
    enteredBy: [],
    type: [],
  });
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [openResumePreviewSignal, setOpenResumePreviewSignal] = useState(0);

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam !== null) {
      const t = parseInt(tabParam, 10);
      if (!isNaN(t)) setValue(t);
    }
  }, [searchParams]);

  useEffect(() => {
    if (value === 3) fetchCandidateActivities();
  }, [value]);

  const fetchFilters = async (jobId = 0) => {
    try {
      setFiltersLoading(true);
      const res = await axios.get(`/get-candidate-filters`, {
        params: { candidate_id: id, joborder_id: jobId },
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      const data = res.data?.message || [];
      if (
        !data[0]?.length ||
        (Array.isArray(data[0]) &&
          data[0].length === 1 &&
          data[0][0]?.job_id === -1)
      ) {
        setDisableLogActivity(true);
      } else {
        setDisableLogActivity(false);
      }
      if (
        Array.isArray(data[0]) &&
        Array.isArray(data[1]) &&
        Array.isArray(data[2])
      ) {
        setFilterOptions({
          regarding: data[0] || [],
          enteredBy: data[1] || [],
          type: data[2] || [],
        });
      } else if (Array.isArray(data[0])) {
        setFilterOptions((prev) => ({ ...prev, enteredBy: data[0] || [] }));
      }
    } catch (err) {
      console.error("Error fetching candidate filters:", err);
    } finally {
      setFiltersLoading(false);
    }
  };

  const handleAddToJobOpen = () => setOpenAddtoJob(true);

  // ── View Resume: switch to Candidate Info tab + open resume preview modal only on click ──
  const handleViewResumeClick = (e) => {
    e?.preventDefault?.();
    setValue(0);
    setOpenResumePreviewSignal((prev) => prev + 1);
  };

  const handleChange = (event, newValue) => setValue(newValue);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const handleAddLogOpen = () => setAddLogOpen(true);
  const handleAddLogClose = () => setAddLogOpen(false);

  const fetchCandidateDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `candidate/details/${id}?isEditableProfile=false`,
        { jobId: id },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      );
      setcandidatedetails(response.data.message);
    } catch (err) {
      console.error("Error fetching candidate details:", err);
    } finally {
      setLoading(false);
      scrollToTop();
    }
  };

  useEffect(() => {
    fetchCandidateDetails();
  }, [id]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  // ── Share Profile: copy URL to clipboard ──
  const copyToClipboard = async () => {
    const x = process.env.REACT_APP_FRONTEND_URL;
    try {
      await navigator.clipboard.writeText(`${x}/Manage-Candidates/${id}`);
      setSnackbarMessage("Copied");
      setAlertSeverity("success");
      setSnackbarOpen(true);
      setTimeout(() => setSnackbarOpen(false), 1500);
    } catch (err) {
      setSnackbarMessage("Failed to copy the link.");
      setAlertSeverity("error");
      setSnackbarOpen(true);
    }
  };

  let tabIndex = -1;
  let customTabIndex = -1;
  const PermissionStatus = useSelector((state) => state.user.permissions);
  const addCandidatePermission = PermissionStatus["100"];

  const [open, setOpen] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);
  const handleAcknowledgeChange = (event) =>
    setAcknowledged(event.target.checked);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDelete = () => {
    try {
      axios.get(`/delete-candidate/${openDrawerId?.id}`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      setSnackbarMessage("Candidate Deleted Successfully");
      setAlertSeverity("success");
      setSnackbarOpen(true);
      setTimeout(() => nav("/Manage-Candidates?page=1"), 800);
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Candidate Deletion Failed");
      setAlertSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setOpen(false);
      setAcknowledged(false);
    }
  };

  const handleFilterApply = (filters) => fetchCandidateActivities(filters);

  const fetchCandidateActivities = (filters = {}) => {
    setLoadingActivities(true);
    axios
      .get(`/get-candidate-activity`, {
        params: {
          joborder_id: filters.regarding || 0,
          candidate_id: id,
          entered_by: filters.enteredBy || "",
          type: filters.type || "",
          limit: filters?.paginationModel?.pageSize || 10,
          offset: filters?.paginationModel?.page || 0,
        },
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((response) => {
        const data = response.data?.message?.[0] || [];
        const rows = response.data?.message?.[1][0].totalActivities || 0;
        setActivitiesData((prevState) => ({
          ...prevState,
          activityData: data,
          totalRows: rows,
        }));
      })
      .catch(console.error)
      .finally(() => setLoadingActivities(false));
  };

  const handleBack = () => {
    const previousUrl = sessionStorage.getItem("manageCandidatepreviousUrl");
    if (previousUrl) {
      const url = new URL(previousUrl, window.location.origin);
      nav(`${url.pathname}${url.search}`);
      sessionStorage.removeItem("manageCandidatepreviousUrl");
    } else {
      nav("/Manage-Candidates?page=1");
    }
  };

  return (
    <>
      {loading ? (
        // ── Full page shimmer — same layout as actual page ──
        <Box
          sx={{
            backgroundColor: "#E3F2FD",
            height: "100%",
            borderRadius: "24px 0 0 0",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FFF",
              borderRadius: "12px",
              padding: "16px",
              height: "100%",
              gap: "16px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header shimmer */}
            <Box
              sx={{
                display: "flex",
                borderBottom: "1px solid rgba(21,29,72,0.12)",
                paddingBottom: "16px",
                gap: "12px",
                alignItems: "center",
              }}
            >
              <Skeleton variant="rounded" width={24} height={24} />
              <Skeleton variant="text" width={200} height={28} />
            </Box>

            {/* Candidate info shimmer */}
            <Box
              sx={{ display: "flex", gap: "16px", alignItems: "flex-start" }}
            >
              <Skeleton
                variant="rounded"
                width={100}
                height={100}
                sx={{ borderRadius: "8px", flexShrink: 0 }}
              />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Skeleton variant="text" width={200} height={28} />
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Skeleton variant="rounded" width={100} height={36} />
                    <Skeleton variant="rounded" width={130} height={36} />
                  </Box>
                </Box>
                <Skeleton
                  variant="text"
                  width={160}
                  height={20}
                  sx={{ mb: 0.5 }}
                />
                <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
                  <Skeleton variant="text" width={180} height={18} />
                  <Skeleton variant="text" width={160} height={18} />
                  <Skeleton variant="text" width={200} height={18} />
                </Box>
                <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                  {[80, 110, 90, 120].map((w, i) => (
                    <Skeleton
                      key={i}
                      variant="rounded"
                      width={w}
                      height={28}
                      sx={{ borderRadius: "20px" }}
                    />
                  ))}
                </Box>
              </Box>
            </Box>

            {/* Tabs shimmer */}
            <Box
              sx={{
                borderBottom: "1px solid rgba(0,0,0,0.12)",
                display: "flex",
                gap: 3,
                pb: 1,
              }}
            >
              {[110, 130, 130, 90].map((w, i) => (
                <Skeleton key={i} variant="text" width={w} height={20} />
              ))}
            </Box>

            {/* Cards shimmer — 3 columns like actual layout */}
            <Box sx={{ display: "flex", gap: 2, flex: 1 }}>
              {["Basic Details", "Professional Details", "Other Details"].map(
                (title) => (
                  <Box
                    key={title}
                    sx={{
                      flex: "1 1 280px",
                      minWidth: 260,
                      border: "1px solid #c7d9f0",
                      borderRadius: "10px",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* Card header */}
                    <Box sx={{ background: "#dbeafe", px: 2, py: 1.2 }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 700,
                          color: "#1a2e4a",
                        }}
                      >
                        {title}
                      </Typography>
                    </Box>
                    {/* Card body shimmer rows */}
                    <Box sx={{ px: 2, py: 1.5, flex: 1 }}>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                        <Box key={i} sx={{ display: "flex", gap: 2, mb: 1.2 }}>
                          <Skeleton
                            variant="text"
                            width="38%"
                            height={16}
                            sx={{ borderRadius: "6px" }}
                          />
                          <Skeleton
                            variant="text"
                            width="50%"
                            height={16}
                            sx={{ borderRadius: "6px" }}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ),
              )}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: "#E3F2FD",
            height: "100%",
            borderRadius: "24px 0 0 0",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FFF",
              borderRadius: "12px",
              padding: "16px",
              height: "100%",
              gap: "16px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* ── Header bar ── */}
            <Box
              sx={{
                display: "flex",
                borderBottom: "1px solid rgba(21, 29, 72, 0.12)",
                paddingBottom: "16px",
                gap: "12px",
                alignItems: "center",
              }}
            >
              <Button
                startIcon={
                  <ChevronLeftOutlinedIcon
                    style={{ height: "16px", width: "16px" }}
                  />
                }
                onMouseEnter={() => setHoverBackButton(true)}
                onMouseLeave={() => setHoverBackButton(false)}
                sx={{
                  "& .MuiButton-startIcon": hoverBackButton
                    ? { marginRight: "4px !important" }
                    : { margin: "0px" },
                  padding: "4px",
                  backgroundColor: hoverBackButton ? "#3F95EA" : "#E7E7E7",
                  color: hoverBackButton ? "white" : "#1A1A1A",
                  height: "24px",
                  fontSize: 12,
                  textTransform: "none",
                  minWidth: hoverBackButton ? "12" : 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    backgroundColor: hoverBackButton ? "#3F95EA" : "#E7E7E7",
                  },
                }}
                onClick={handleBack}
              >
                {hoverBackButton ? "Back" : ""}
              </Button>
              <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                Candidate Description
              </Typography>
            </Box>

            {/* ── Candidate Info Section ── */}
            <Box
              sx={{
                display: "flex",
                gap: "16px",
                alignItems: "flex-start",
                flexWrap: { xs: "wrap", md: "nowrap" },
              }}
            >
              <Box
                sx={{
                  width: "100px",
                  height: "100px",
                  backgroundColor: "#E3F2FD",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  overflow: "hidden",
                }}
              >
                {candidatedetails.profile_path ? (
                  <img
                    src={candidatedetails.profile_path}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                    alt="avatar"
                  />
                ) : (
                  <Avatar
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: "8px",
                      fontSize: "48px",
                    }}
                  />
                )}
              </Box>

              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: 600,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "60%",
                    }}
                  >
                    {candidatedetails.name || "NA"}
                  </Typography>
                  <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    {addCandidatePermission?.add === 1 && (
                      <Button
                        variant="contained"
                        onClick={handleAddToJobOpen}
                        sx={{
                          textTransform: "uppercase",
                          background: "#3F95EA",
                        }}
                      >
                        <Typography sx={{ fontSize: "12px", fontWeight: 400 }}>
                          Add to Job
                        </Typography>
                      </Button>
                    )}
                    <Tooltip
                      title={
                        disableLogActivity
                          ? "No jobs associated to log activity"
                          : ""
                      }
                      arrow
                    >
                      <span>
                        <Button
                          variant="outlined"
                          onClick={handleAddLogOpen}
                          disabled={disableLogActivity}
                          sx={{ alignSelf: "flex-start" }}
                        >
                          <Typography
                            sx={{ fontSize: "12px", fontWeight: "400" }}
                          >
                            Log New Activity
                          </Typography>
                        </Button>
                      </span>
                    </Tooltip>

                    {/* Delete button — sirf tab jab Log Activity disabled ho */}
                    {disableLogActivity &&
                      candidatedetails.entered_by !== "Jobeze Admin" &&
                      candidatedetails?.can_edit &&
                      addCandidatePermission?.delete === 1 && (
                        <>
                          <Tooltip title="Delete Candidate">
                            <IconButton
                              onClick={handleOpen}
                              sx={{
                                border: "1px solid #fca5a5",
                                borderRadius: "8px",
                                color: "#ef4444",
                                width: 36,
                                height: 36,
                                "&:hover": {
                                  background: "#fff5f5",
                                  borderColor: "#ef4444",
                                },
                              }}
                            >
                              <DeleteForeverOutlinedIcon
                                sx={{ fontSize: "18px" }}
                              />
                            </IconButton>
                          </Tooltip>
                          <DeleteCanidateDrawer
                            open={open}
                            handleClose={handleClose}
                            handleDelete={handleDelete}
                            candidatename={candidatedetails.name}
                            acknowledged={acknowledged}
                            handleAcknowledgeChange={handleAcknowledgeChange}
                          />
                        </>
                      )}
                  </Box>
                </Box>

                {/* <Tooltip title={candidatedetails.current_employer || ""}> */}
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "rgba(0,0,0,0.60)",
                    fontWeight: "400",
                  }}
                >
                  {candidatedetails.current_employer || "NA"}
                </Typography>
                {/* </Tooltip> */}

                {/* Metadata */}
                {(() => {
                  const getRelativeDate = (dateStr) => {
                    if (!dateStr) return "More than 90 days ago";
                    const daysAgo = dayjs().diff(dayjs(dateStr), "days");
                    if (daysAgo <= 7) return "Last 7 days";
                    if (daysAgo <= 30) return "Last month";
                    if (daysAgo <= 90) return "Last 90 days";
                    return "More than 90 days ago";
                  };
                  const metaItems = [];
                  if (
                    candidatedetails?.entered_by === "Jobeze Admin" ||
                    candidatedetails?.last_login
                  )
                    metaItems.push({
                      label: "Last Login:",
                      value: getRelativeDate(candidatedetails?.last_login),
                    });
                  if (
                    candidatedetails?.entered_by === "Jobeze Admin" ||
                    candidatedetails?.last_job_applied_date
                  )
                    metaItems.push({
                      label: "Last Job Applied:",
                      value: getRelativeDate(
                        candidatedetails?.last_job_applied_date,
                      ),
                    });
                  if (
                    candidatedetails?.entered_by === "Jobeze Admin" ||
                    candidatedetails?.last_profile_update
                  )
                    metaItems.push({
                      label: "Last Profile Updated On:",
                      value: getRelativeDate(
                        candidatedetails?.last_profile_update,
                      ),
                    });
                  return (
                    <Box>
                      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                        {metaItems.map((item, idx) => (
                          <Box
                            key={idx}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <Typography
                              sx={{ fontSize: "13px", color: "#00000099" }}
                            >
                              {item.label}&nbsp;
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "13px",
                                fontWeight: 700,
                                color: "#00000099",
                              }}
                            >
                              {item.value}
                            </Typography>
                            {idx < metaItems.length - 1 && (
                              <Typography sx={{ mx: 1.5, color: "#00000040" }}>
                                •
                              </Typography>
                            )}
                          </Box>
                        ))}
                      </Box>
                      {candidatedetails?.candidate_view_count ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            mt: 0.5,
                          }}
                        >
                          <VisibilityIcon
                            sx={{ fontSize: "15px", color: "#00000060" }}
                          />
                          <Typography
                            sx={{ fontSize: "13px", color: "#00000099" }}
                          >
                            {candidatedetails.candidate_view_count} views in
                            last 90 days
                          </Typography>
                        </Box>
                      ) : null}
                    </Box>
                  );
                })()}

                {/* ── Action Chips ── */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 1.5,
                    flexWrap: "nowrap",
                    overflowX: "auto",
                  }}
                >
                  {(() => {
                    const chipSx = {
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      backgroundColor: "#F9F9F9",
                      color: "#212121",
                      borderRadius: "20px",
                      padding: "5px 14px",
                      fontSize: "12px",
                      fontWeight: 400,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      textDecoration: "none",
                      "&:hover": { backgroundColor: "rgb(227,242,253)" },
                    };

                    // LinkedIn href — original logic: use value directly, null if missing
                    const linkedInHref = candidatedetails.linkedIn
                      ? candidatedetails.linkedIn
                      : null;

                    return (
                      <>
                        {/* Email — mailto link, same as original */}
                        <Box
                          component="a"
                          href={"mailto:" + candidatedetails.email}
                          target="_blank"
                          rel="noreferrer"
                          sx={chipSx}
                        >
                          <MailOutlineIcon sx={{ fontSize: "12px" }} />
                          Email
                        </Box>

                        {/* View Resume — opens preview modal only on click (no auto-open on page load) */}
                        <Box
                          component="button"
                          type="button"
                          onClick={handleViewResumeClick}
                          sx={{
                            ...chipSx,
                            border: "none",
                            backgroundColor: "#F9F9F9",
                            fontSize: "12px",
                            fontWeight: 400,
                          }}
                        >
                          <InsertDriveFileOutlinedIcon
                            sx={{ fontSize: "16px" }}
                          />
                          View Resume
                        </Box>

                        {/* LinkedIn — original logic: href directly from data */}
                        <Box
                          component="a"
                          href={linkedInHref}
                          target={linkedInHref ? "_blank" : undefined}
                          rel="noreferrer"
                          sx={{
                            ...chipSx,
                            // dim chip if no LinkedIn URL, prevent click
                            opacity: linkedInHref ? 1 : 0.4,
                            cursor: linkedInHref ? "pointer" : "default",
                            pointerEvents: linkedInHref ? "auto" : "none",
                          }}
                        >
                          LinkedIn
                          <OpenInNewIcon sx={{ fontSize: "14px" }} />
                        </Box>

                        {/* Share Profile — copyToClipboard */}
                        <Box
                          component="span"
                          sx={chipSx}
                          onClick={copyToClipboard}
                        >
                          <ShareIcon sx={{ fontSize: "16px" }} />
                          Share Profile
                        </Box>
                      </>
                    );
                  })()}
                </Box>
              </Box>
            </Box>

            <AddLogActivity
              open={addLogOpen}
              onClose={handleAddLogClose}
              candidateId={id}
              regardingOptions={filterOptions.regarding}
              activityOptions={filterOptions.type}
              filtersLoading={filtersLoading}
              onActivityAdded={() => {
                if (value === 3) fetchCandidateActivities();
                else setValue(3);
              }}
            />

            {/* ── Tabs ── */}
            <Tabs
              value={value}
              onChange={handleChange}
              style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
              sx={{ "& .MuiTabs-indicator": { height: "2px" } }}
              aria-label="candidate tabs"
            >
              <Tab
                label="CANDIDATE INFO"
                {...a11yProps(++tabIndex)}
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "rgba(0, 0, 0, 0.60)",
                }}
              />
              <Tab
                label="INTERNAL PROFILE"
                {...a11yProps(++tabIndex)}
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "rgba(0, 0, 0, 0.60)",
                }}
              />
              <Tab
                label="JOBS ASSOCIATED"
                {...a11yProps(++tabIndex)}
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "rgba(0, 0, 0, 0.60)",
                }}
              />
              <Tab
                label="ACTIVITIES"
                {...a11yProps(++tabIndex)}
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "rgba(0, 0, 0, 0.60)",
                }}
              />
            </Tabs>

            <CustomTabPanel value={value} index={++customTabIndex}>
              <CandidateInfo
                candidatedetails={candidatedetails}
                refreshCandidateDetails={fetchCandidateDetails}
                openResumePreviewSignal={openResumePreviewSignal}
                loading={loading}
                layout="row"
              />
            </CustomTabPanel>

            <CustomTabPanel
              value={value}
              index={++customTabIndex}
              sx={{ height: "100%", overflowY: "hidden" }}
            >
              <CandidateEditableProfile candidateId={openDrawerId?.id} />
            </CustomTabPanel>

            <CustomTabPanel value={value} index={++customTabIndex}>
              <Box sx={{ width: "100%", height: "calc(100vh - 412px)" }}>
                <JobAssociated />
              </Box>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={++customTabIndex}>
              <Activities
                activityData={activitiesData.activityData}
                totalRows={activitiesData.totalRows}
                onApplyFilter={handleFilterApply}
                onResetFilter={() => fetchCandidateActivities()}
                gridLoading={loadingActivities}
                regardingOptions={filterOptions.regarding}
                enteredByOptions={filterOptions.enteredBy}
                typeOptions={filterOptions.type}
                onRegardingChange={fetchFilters}
                filtersLoading={filtersLoading}
              />
            </CustomTabPanel>
          </Box>

          <AddToJobBtn
            openAddtoJob={openAddtoJob}
            setRenderKey={setRenderKey}
            setOpenAddtoJob={setOpenAddtoJob}
            addToJobCandidateids={[Number(id)]}
            setSelectedRows={setSelectedRows}
            setAddToJobCandidateids={setAddToJobCandidateids}
            onCandidateAdded={() => {
              fetchFilters();
              fetchCandidateActivities();
            }}
          />

          {/* Snackbar for Share Profile */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity={alertSeverity}
              variant="filled"
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Box>
      )}
    </>
  );
};

export default OpenDrawer;
